module.exports = __webpack_public_path__ + "img/20220411_140154.0467a88b.jpg";